<div class='wrapper alert alert-warning' role="alert">
  <p>{{info}}</p>
  <ng-content>
  </ng-content>
  <button type='button' class='btn btn-primary' [routerLink]='"/help"'>
      Перейти на страницу справки
  </button>
</div>
